export default "__VITE_ASSET__BrpIlDuM__"